/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import { beneTxnSuccessDetail } from "../../../../redux/features/beneficiary/beneTxnAccounts/beneTransactionAccounts";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";
import useCategories from "../../../../utils/useCategories";

const BeneficiaryTransactionSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const categoryMapper = useCategories();

  const transaction = useSelector((state) => state.beneTransactionAccounts);
  const beneTxnSuccessDataError = useSelector(
    (state) => state.beneTransactionAccounts.beneTxnSuccessDataError,
  );
  const beneTxnSuccessLoading = useSelector(
    (state) => state.beneTransactionAccounts.beneTxnSuccessLoading,
  );

  const viewDetailsHandler = () => {
    navigate(
      `/beneficiary_transaction_dashboard/beneficiary_transaction_view_all/beneficiary_transaction_detail_page/${id}`,
      {
        replace: true,
      },
    );
  };

  const beneAccount = () => {
    const beneId =
      transaction?.beneTxnSuccessData?.transaction[0]?.beneficiary_account_id;

    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${beneId}`,
      {
        replace: true,
      },
    );
  };

  const sourceAccount = () => {
    const sourceId =
      transaction?.beneTxnSuccessData?.transaction[0]?.owner_account_id;
    navigate(
      `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${sourceId}`,
      {
        replace: true,
      },
    );
  };

  const status =
    transaction?.beneTxnSuccessData?.transaction[0]?.lifecycle_status;

  const createAccountHandler = () => {
    navigate(
      "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
      {
        replace: true,
      },
    );
    try {
      sessionStorage.removeItem("recreate_ben");
    } catch {}
  };

  const dashboardHandler = () => {
    navigate("/beneficiary_transaction_dashboard", {
      replace: true,
    });
  };

  const buttonRows = [
    [
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(disableSwitcher());
    // The next lines are commented out as a deliberate reminder to not re
    // enable the switcher when exiting this page since it will be re enabled by
    // whereever one may navigate anyways

    // return () => {
    //   dispatch(enableSwitcher());
    // }
  }, []);

  useEffect(() => {
    if (beneTxnSuccessDataError === "Request failed with status code 404") {
      navigate(
        `/beneficiary_transaction_dashboard/create_beneficiary_transaction/failed`,
      );
    }
  }, [beneTxnSuccessDataError]);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(beneTxnSuccessDetail(id));
    }
  }, [id, dispatch]);

  return (
    <>
      <StatusContainer
        isLoading={beneTxnSuccessLoading}
        status="success"
        hoverOption="white"
        title={
          status === "approved"
            ? "Beneficiary transaction has been created and approved"
            : status === "queued"
              ? "Beneficiary transaction has been approved"
              : status === "settled"
                ? "Beneficiary transaction settled successfully."
                : status === "pending"
                  ? "Beneficiary transaction created successfully and approval is pending."
                  : ""
        }
        subtitle={
          status === "approved" || status === "queued"
            ? "It will be auto settled once sufficient balance is available in the source account."
            : ""
        }
        buttonRows={buttonRows}
      >
        <TabsWeapperSection title="Transaction details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountNameStandardised(
                    transaction?.beneTxnSuccessData?.transaction[0]
                      ?.beneficiary_account_name,
                  ),
                  leftSubTitle: "Beneficiary name",
                  hasRight: true,
                  rightText: true,
                  rightTitleTextColor: "var(--text-primary)",
                  rightTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={
                          transaction?.beneTxnSuccessData?.transaction[0]
                            ?.amount ?? GlobalConfiguration?.lengthCheckZero
                        }
                      />
                    </>
                  ),
                  rightTextFontWeight: "semibold",
                  rightSubTitle: "Amount",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={beneAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    transaction?.beneTxnSuccessData?.transaction[0]
                      ?.beneficiary_account_bank_acc_no,
                  ),
                  leftSubTitle: globalText?.BENEFICIARY_ACCOUNT_NUMBER,
                  ifsc: transaction?.beneTxnSuccessData?.transaction[0]
                    ?.beneficiary_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    transaction?.beneTxnSuccessData?.transaction[0]?.category,
                  leftSubTitle: "Transaction category",
                  icon: categoryMapper(
                    transaction?.beneTxnSuccessData?.transaction[0]?.category,
                  ),
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={sourceAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    transaction?.beneTxnSuccessData?.transaction[0]
                      ?.owner_account_bank_acc_no,
                  ),
                  leftSubTitle: globalText?.SOURCE_ACCOUNT_NUMBER,
                  ifsc: transaction?.beneTxnSuccessData?.transaction[0]
                    ?.owner_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            {transaction?.beneTxnSuccessData?.transaction[0]
              ?.confidential_transaction === "Y" && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: globalText?.YES,
                    leftSubTitle: globalText?.CONFIDENTIAL_TRANSACTION,
                    icon: ICONS?.CONFIDENTIAL_TRANSACTION_BLUE_BG,
                  },
                ]}
              />
            )}

            {(transaction?.beneTxnSuccessData?.transaction[0]
              ?.lifecycle_status === "pending" ||
              transaction?.beneTxnSuccessData?.transaction[0]
                ?.lifecycle_status === "approved") && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle:
                      transaction?.beneTxnSuccessData?.transaction[0]
                        ?.lifecycle_status === "pending" &&
                      !beneTxnSuccessLoading
                        ? "Pending"
                        : transaction?.beneTxnSuccessData?.transaction[0]
                              ?.lifecycle_status === "approved" &&
                            !beneTxnSuccessLoading
                          ? "Created distribution"
                          : "",
                    leftSubTitle: globalText?.TRANSACTION_STATUS,
                    icon:
                      transaction?.beneTxnSuccessData?.transaction[0]
                        ?.lifecycle_status === "pending"
                        ? ICONS?.PENDING_BLUE
                        : transaction?.beneTxnSuccessData?.transaction[0]
                              ?.lifecycle_status === "approved"
                          ? ICONS?.AWAITING_VERIFICATION
                          : ICONS?.LOADER,
                    iconColor:
                      transaction?.beneTxnSuccessData?.transaction[0]
                        ?.lifecycle_status === "approved"
                        ? "var(--awaiting)"
                        : "",
                  },
                ]}
              />
            )}

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    Array.isArray(
                      transaction?.beneTxnSuccessData?.transaction[0]?.labels,
                    ) &&
                    transaction?.beneTxnSuccessData?.transaction[0]?.labels
                      .length > 0
                      ? transaction?.beneTxnSuccessData?.transaction[0]?.labels.map(
                          (item, index, arr) => (
                            <span key={index}>
                              {item}
                              {index <
                                arr.length -
                                  GlobalConfiguration?.lengthCheckOne && ", "}
                            </span>
                          ),
                        )
                      : globalText?.NO_LABELS_ASSIGNED,
                  leftSubTitle: "Assigned labels",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default BeneficiaryTransactionSuccess;
